import React, { Dispatch, SetStateAction, useContext } from 'react';

type AlertKey = number;
export type AlertAction = {
    name: string;
    alertId?: AlertKey;
};

type ContextType = {
    action: AlertAction;
    setAction: Dispatch<SetStateAction<AlertAction>>;
};

const initialContext: ContextType = {
    action: { name: 'list' },
    setAction: () => ({ name: 'list' }),
};
export const AlertActionContext =
    React.createContext<ContextType>(initialContext);

export const useAlertAction = () => useContext(AlertActionContext);
